import PostList from "./pages/PostList";
import PostDetail from "./pages/PostDetail";
import CreatePost from "./pages/CreatePost";
import { Router, Route, LocationProvider } from "preact-iso";
import GithubCallback from "./pages/GithubCallback";

export default function App() {
  return (
    <div>
      <header style={{ padding: "12px", borderBottom: "1px solid #ddd" }}>
        <nav style={{ display: "flex", gap: 12 }}>
          <a href="/">博客列表</a>
        </nav>
      </header>
      <main style={{ padding: 16 }}>
        <LocationProvider>
          <Router>
            <Route path="/" component={PostList} />
            <Route path="/post/:id" component={PostDetail} />
            <Route path="/create" component={CreatePost} />
            <Route path="/github_cb" component={GithubCallback} />
          </Router>
        </LocationProvider>
      </main>
    </div>
  );
}
